import { type IMatchConfigEntry, isProceduralMapConfig } from '@nova/types';
import { type StubTiledMapOptions } from '@nova/utils';

import { getProceduralMapTfConfig, proceduralMapTfToStubOptions, type ProceduralStubResolveOptions } from './procedural-map-tf.config';

/**
 * Stub dimensions for a lobby match config when it is procedural; `undefined` for CDN maps.
 * Throws if the map opts into procedural generation but no catalog entry matches its id.
 * Match-type catalogs append inside the lookup; AGE/RE callers stay match-type-agnostic.
 *
 * Pass `tilePx` from the shared action-game `pxPerUnit` when available so stub pitch matches the engine.
 */
export function resolveProceduralStubOptions(
  matchConfig: IMatchConfigEntry,
  options?: ProceduralStubResolveOptions
): StubTiledMapOptions | undefined {
  if (!isProceduralMapConfig(matchConfig)) {
    return undefined;
  }

  const tfMap = getProceduralMapTfConfig(matchConfig.id);
  if (tfMap) {
    return proceduralMapTfToStubOptions(tfMap, options);
  }

  throw new Error(`[resolveProceduralStubOptions] missing procedural stub options for map id <${matchConfig.id}>`);
}
